  if (!customElements.get('igk-outlet-reviews')) {
    customElements.define('igk-outlet-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.startSync(); return; }
        this.initialized = true;
        if (!this.querySelector('[data-panel]')) return;
        this.page = 1;
        this.rating = 0;
        this.rows = [...this.querySelectorAll('[data-review]')];
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('input', event => { if (event.target.matches('[data-search]')) { this.page = 1; this.render(); } });
        this.addEventListener('change', event => { if (event.target.matches('[data-sort]')) { this.page = 1; this.render(); } });
        this.querySelector('[role=tablist]').addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.tabs.indexOf(document.activeElement);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - Math.max(0, index);
          this.selectTab(this.tabs[next].dataset.tab);
          this.tabs[next].focus();
        });
        this.anchorHandler = event => {
          const link = event.target.closest('a[href="#looxReviews"]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.selectTab('reviews');
          this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        };
        document.addEventListener('click', this.anchorHandler);
        const dialog = this.querySelector('[data-review-dialog]');
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        const photoDialog = this.querySelector('[data-photo-dialog]');
        photoDialog.addEventListener('click', event => { if (event.target === photoDialog) photoDialog.close(); });
        photoDialog.addEventListener('close', () => {
          photoDialog.querySelector('[data-photo-full]').removeAttribute('src');
          if (this.photoTrigger?.isConnected) this.photoTrigger.focus({ preventScroll: true });
        });
        this.render();
        this.startSync();
        if (this.querySelector('[data-question-success], [data-question-error]') || location.hash === '#' + this.querySelector('form').id) this.selectTab('questions');
      }
      disconnectedCallback() {
        if (this.anchorHandler) document.removeEventListener('click', this.anchorHandler);
        clearInterval(this.syncTimer);
        this.syncController?.abort();
        if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
      startSync() {
        if (!this.querySelector('[data-panel]')) return;
        if (this.anchorHandler) document.addEventListener('click', this.anchorHandler);
        clearInterval(this.syncTimer);
        if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.visibilityHandler = () => { if (!document.hidden) this.syncReviews(); };
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.syncReviews();
        this.syncTimer = setInterval(() => {
          const bounds = this.getBoundingClientRect();
          if (!document.hidden && bounds.bottom > 0 && bounds.top < innerHeight) this.syncReviews();
        }, 60000);
      }
      async syncReviews() {
        if (this.syncing || !this.dataset.productId || Date.now() - (this.lastSync || 0) < 55000) return;
        this.syncing = true;
        this.syncController = new AbortController();
        const timeout = setTimeout(() => this.syncController.abort(), 12000);
        try {
          const url = new URL(`https://loox.io/widget/${encodeURIComponent(this.dataset.looxClient)}/${encodeURIComponent(this.dataset.productId)}/reviews-data`);
          url.search = new URLSearchParams({ page: '1', limit: '50', sort: 'newest', currentTab: 'product', h: String(Math.floor(Date.now() / 60000)) });
          const response = await fetch(url, { credentials: 'omit', headers: { Accept: 'application/json' }, signal: this.syncController.signal });
          if (!response.ok) throw new Error('Loox unavailable');
          const data = await response.json();
          if (!Array.isArray(data.reviews) || data.status !== 'visible') throw new Error('Invalid Loox response');
          const reviews = new Map(data.reviews.map(review => [String(review._id), review]));
          this.rows.forEach(row => {
            const review = reviews.get(row.dataset.reviewId);
            if (!review) return;
            const author = row.querySelector('.igk-reviews__author');
            let badge = author.querySelector('.igk-reviews__verified');
            if (review.verified === true) {
              if (!badge) {
                badge = this.querySelector('[data-verified-template]').content.firstElementChild.cloneNode(true);
                author.querySelector('strong').after(badge);
              }
              badge.dataset.verificationSource = 'loox-live';
            } else if (review.verified === false) badge?.remove();
            if (Array.isArray(review.media)) this.updatePhotos(row, review.media);
          });
          this.lastSync = Date.now();
          this.dataset.looxSync = 'ready';
        } catch (error) {
          this.dataset.looxSync = 'fallback';
        } finally {
          clearTimeout(timeout);
          this.syncing = false;
        }
      }
      updatePhotos(row, media) {
        const gallery = row.querySelector('[data-review-photos]');
        if (!gallery) return;
        const photos = media.filter(item => item.type === 'photo' && typeof item.image === 'string').flatMap(item => {
          try {
            const source = item.image.trim();
            const url = new URL(source.startsWith('//') ? `https:${source}` : source);
            return url.protocol === 'https:' ? [{ ...item, image: url.href }] : [];
          } catch { return []; }
        });
        const signature = JSON.stringify(photos);
        if (gallery.dataset.mediaSignature === signature) return;
        gallery.dataset.mediaSignature = signature;
        gallery.replaceChildren();
        photos.forEach(item => {
          const link = document.createElement('a');
          link.className = 'igk-reviews__photo';
          link.dataset.reviewPhoto = '';
          link.href = item.image;
          link.target = '_blank';
          link.rel = 'noopener';
          link.setAttribute('aria-label', this.dataset.enlargeLabel);
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.altText || `${this.dataset.photoLabel} — ${row.querySelector('.igk-reviews__author strong').textContent}`;
          image.width = Number(item.imageWidth) || 640;
          image.height = Number(item.imageHeight) || 480;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.addEventListener('error', () => { link.remove(); gallery.hidden = gallery.children.length === 0; });
          link.append(image);
          gallery.append(link);
        });
        gallery.hidden = photos.length === 0;
      }
      selectTab(name) {
        this.tabs.forEach(tab => { const active = tab.dataset.tab === name; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
      }
      async onClick(event) {
        const target = event.target.closest('button,a');
        if (!target || !this.contains(target)) return;
        if (target.hasAttribute('data-review-photo')) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const dialog = this.querySelector('[data-photo-dialog]');
          const image = dialog.querySelector('[data-photo-full]');
          image.src = target.href;
          image.alt = target.querySelector('img').alt;
          this.photoTrigger = target;
          if (!dialog.open) dialog.showModal();
          return;
        }
        if (target.hasAttribute('data-close-photo')) { this.querySelector('[data-photo-dialog]').close(); return; }
        if (target.hasAttribute('data-write-review')) {
          event.preventDefault();
          const dialog = this.querySelector('[data-review-dialog]');
          const frame = dialog.querySelector('[data-review-frame]');
          if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
          if (!dialog.open) dialog.showModal();
          return;
        }
        if (target.hasAttribute('data-close-review')) { this.querySelector('[data-review-dialog]').close(); return; }
        if (target.hasAttribute('data-tab')) this.selectTab(target.dataset.tab);
        if (target.hasAttribute('data-ask-question')) { event.preventDefault(); this.selectTab('questions'); this.querySelector('form').scrollIntoView({ block: 'center' }); this.querySelector('input[name="contact[name]"]').focus({ preventScroll: true }); }
        if (target.hasAttribute('data-rating-filter')) { this.rating = this.rating === Number(target.dataset.ratingFilter) ? 0 : Number(target.dataset.ratingFilter); this.page = 1; this.querySelector('[data-panel="reviews"]').hidden = false; this.selectTab('reviews'); this.querySelector('.igk-reviews__filters').hidden = false; this.querySelector('[data-filter-toggle]').setAttribute('aria-expanded','true'); this.render(); }
        if (target.hasAttribute('data-filter-toggle')) { const filters = this.querySelector('.igk-reviews__filters'); filters.hidden = !filters.hidden; target.setAttribute('aria-expanded', String(!filters.hidden)); if (!filters.hidden) filters.querySelector('input').focus(); }
        if (target.hasAttribute('data-clear')) { this.rating = 0; this.page = 1; this.querySelector('[data-search]').value = ''; this.render(); }
        if (target.hasAttribute('data-prev') || target.hasAttribute('data-next') || target.hasAttribute('data-page')) { this.page = target.hasAttribute('data-page') ? Number(target.dataset.page) : this.page + (target.hasAttribute('data-next') ? 1 : -1); this.render(); this.querySelector('.igk-reviews__toolbar').scrollIntoView({block:'start'}); }
        if (target.hasAttribute('data-share')) {
          const row = target.closest('[data-review]');
          const url = new URL(location.pathname, location.origin); url.hash = row.id;
          const data = { title: document.title, text: row.querySelector('[data-review-text]').textContent.trim(), url: url.href };
          try { if (navigator.share) await navigator.share(data); else { await navigator.clipboard.writeText(url.href); this.querySelector('[data-status]').textContent = this.dataset.copied; } }
          catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-status]').textContent = this.dataset.shareFailed; }
        }
      }
      render() {
        const search = this.querySelector('[data-search]').value.trim().toLowerCase();
        const mode = this.querySelector('[data-sort]').value;
        const filtered = this.rows.filter(row => (!this.rating || Number(row.dataset.rating) === this.rating) && (!search || row.textContent.toLowerCase().includes(search)));
        filtered.sort((a,b) => { const delta = Number(b.dataset.rating)-Number(a.dataset.rating); return (mode === 'highest' ? delta : mode === 'lowest' ? -delta : 0) || Date.parse(b.dataset.date)-Date.parse(a.dataset.date); });
        const size = Number(this.dataset.pageSize), pages = Math.ceil(filtered.length / size);
        this.page = Math.max(1, Math.min(this.page, pages || 1));
        this.rows.forEach(row => { row.hidden = true; });
        const list = this.querySelector('.igk-reviews__list');
        filtered.forEach((row,index) => { list.append(row); row.hidden = index < (this.page-1)*size || index >= this.page*size; });
        this.querySelector('[data-no-results]').hidden = filtered.length > 0;
        this.querySelectorAll('[data-rating-filter]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.ratingFilter) === this.rating)));
        this.querySelector('[data-pagination]').hidden = pages < 2;
        this.querySelector('[data-prev]').disabled = this.page === 1;
        this.querySelector('[data-next]').disabled = this.page >= pages;
        const buttons = this.querySelector('[data-page-buttons]'); buttons.replaceChildren();
        for (let page=1; page<=pages; page++) { const button = document.createElement('button'); button.type = 'button'; button.textContent = String(page); button.dataset.page = String(page); if (page===this.page) button.setAttribute('aria-current','page'); buttons.append(button); }
      }
    });
  }
